import React, { useId } from 'react';

interface VehicleIconProps {
  className?: string;
  size?: number;
}

export const VehicleIcon: React.FC<VehicleIconProps> = ({ className = '', size }) => {
  const sizeProps = size ? { width: size, height: size } : {};
  const uid = useId();
  const id = (name: string) => `${uid}-${name}`;

  return (
    <svg
      {...sizeProps}
      className={className}
      viewBox="0 0 512 512"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <linearGradient id={id('linearGradient14')}>
          <stop offset="0" style={{ stopColor: '#f8fae5', stopOpacity: 1 }} />
          <stop offset="1" style={{ stopColor: '#f1da83', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id={id('linearGradient10')}>
          <stop offset="0" style={{ stopColor: '#158e1c', stopOpacity: 1 }} />
          <stop offset="1" style={{ stopColor: '#298a2f', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id={id('linearGradient7')}>
          <stop offset="0" style={{ stopColor: '#46e84e', stopOpacity: 1 }} />
          <stop offset="0.36290351" style={{ stopColor: '#4eca55', stopOpacity: 1 }} />
          <stop offset="0.50503945" style={{ stopColor: '#39ad42', stopOpacity: 1 }} />
          <stop offset="1" style={{ stopColor: '#298a2f', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id={id('linearGradient5')}>
          <stop offset="0" style={{ stopColor: '#039ef5', stopOpacity: 1 }} />
          <stop offset="1" style={{ stopColor: '#57f2ee', stopOpacity: 1 }} />
        </linearGradient>

        <linearGradient
          id={id('linearGradient6')}
          xlinkHref={`#${id('linearGradient5')}`}
          x1="206.7224"
          y1="87.857025"
          x2="164.51659"
          y2="193.80226"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1.1123404,0,0,1.1123404,-28.202611,-10.346934)"
        />
        <radialGradient
          id={id('radialGradient8')}
          xlinkHref={`#${id('linearGradient7')}`}
          cx="250.34108"
          cy="287.87332"
          fx="250.34108"
          fy="287.87332"
          r="228.02455"
          gradientTransform="matrix(1.9365763,-0.07001244,0.03494011,0.96645903,-230.34026,-13.416327)"
          gradientUnits="userSpaceOnUse"
        />
        <radialGradient
          id={id('radialGradient8-9')}
          xlinkHref={`#${id('linearGradient10')}`}
          cx="196.56731"
          cy="259.48639"
          fx="196.56731"
          fy="259.48639"
          r="228.02455"
          gradientTransform="matrix(1.7032771,-0.1252284,0.08272118,1.1251209,-165.82559,3.530372)"
          gradientUnits="userSpaceOnUse"
        />
        <radialGradient
          id={id('radialGradient15')}
          xlinkHref={`#${id('linearGradient14')}`}
          cx="175.18839"
          cy="265.77231"
          fx="175.18839"
          fy="265.77231"
          r="29.957975"
          gradientTransform="matrix(1,0,0,1.3678562,0,-97.765995)"
          gradientUnits="userSpaceOnUse"
        />
        <radialGradient
          id={id('radialGradient17')}
          xlinkHref={`#${id('linearGradient14')}`}
          cx="-331.05313"
          cy="404.69684"
          fx="-331.05313"
          fy="404.69684"
          r="29.957975"
          gradientTransform="matrix(1,0,0,1.3678562,0,-148.87025)"
          gradientUnits="userSpaceOnUse"
        />
      </defs>

      <rect x="56.127575" y="369.16147" width="69.103371" height="119.23721" fill="#464646" rx="2.5437903" ry="2.5437903" />
      <rect x="390.8251" y="369.16147" width="69.103371" height="119.23721" fill="#464646" rx="2.5437903" ry="2.5437903" />
      <rect x="117.36433" y="74.799042" width="6.0294037" height="74.075531" fill="#6b6b6b" transform="rotate(-24.04262)" />

      <path
        d="M 245.48204,56.172879 C 133.84786,58.176454 107.60945,112.03418 64.718015,206.78639 c -24.152103,0 -21.952695,-20.48983 -57.604899,-1.8836 -6.4203195,3.35065 -7.0728767,17.2576 9.580902,31.99718 18.40337,16.28809 20.635925,9.45536 46.107818,5.71595 0.01668,6.11271 -0.709674,38.7861 -2.370241,44.68915 -0.954799,3.39416 -11.529006,21.82591 -14.397424,34.11323 -9.480111,40.60954 -1.921576,43.16301 0.252015,80.15802 0.177327,3.01814 1.663008,4.89698 3.071972,5.46395 55.595812,22.37159 88.455422,31.71095 207.197302,32.57941 118.7419,-0.86846 151.60367,-10.20782 207.19949,-32.57941 1.40898,-0.56697 2.89248,-2.44581 3.06982,-5.46395 2.17358,-36.99501 9.73429,-39.54848 0.25417,-80.15802 -2.86841,-12.28732 -13.44264,-30.71907 -14.39742,-34.11323 -1.66056,-5.90305 -2.38909,-38.57644 -2.37241,-44.68915 25.4719,3.73941 27.70662,10.57214 46.10998,-5.71595 16.65378,-14.73958 16.00122,-28.64653 9.58091,-31.99718 -35.65222,-18.60623 -33.45498,1.8836 -57.60707,1.8836 C 404.1179,108.97766 377.58748,53.869148 256.55546,56.18374 c -3.78224,-0.07232 -7.47233,-0.07549 -11.07342,-0.01091 z"
        fill={`url(#${id('radialGradient8')})`}
      />
      <path
        d="m 266.5893,55.797454 c -3.6011,-0.03937 -7.29197,-0.0235 -11.07422,0.04883 -3.78223,-0.07232 -7.47118,-0.0763 -11.07226,-0.01172 -62.59398,1.123417 -98.33677,18.557056 -125.22461,50.353516 A 216.82597,126.07578 0 0 0 247.42719,130.7701 216.82597,126.07578 0 0 0 387.2143,100.74276 C 360.83967,72.11085 325.6957,56.443719 266.5893,55.797454 Z"
        fill="#2e913b"
      />
      <path
        d="m 31.40737,197.09528 c -5.70755,-0.003 -13.15167,1.99416 -24.29297,7.80859 -6.4203,3.35065 -7.07366,17.25654 9.58008,31.9961 18.39703,16.28247 20.63678,9.46093 46.08399,5.7207 l 0.0254,-0.0273 1.91406,-35.80664 c -16.60454,0 -20.75392,-9.68485 -33.31055,-9.69141 z m 450.29883,0 c -12.55778,0.007 -16.70797,9.69141 -33.3125,9.69141 l 1.91602,35.83008 c 25.47184,3.73939 27.70605,10.57125 46.10937,-5.7168 16.65376,-14.73956 16.00234,-28.64545 9.58203,-31.9961 -11.14129,-5.81443 -18.58684,-7.81157 -24.29492,-7.80859 z m -31.39648,45.52149 h -0.0957 l 0.0918,0.14257 c 1.5e-4,-0.0483 0.004,-0.0943 0.004,-0.14257 z"
        fill={`url(#${id('radialGradient8-9')})`}
      />
      <ellipse cx="262.43805" cy="382.71112" rx="101.17317" ry="57.816948" fill="#000000" fillOpacity="0.0729483" />
      <path
        d="m 41.902732,345.75726 c -2.018687,20.29047 2.714122,28.57417 4.371153,56.77717 0.177318,3.01814 1.663005,4.89697 3.071961,5.46393 55.595764,22.37157 88.455554,31.71096 207.197314,32.57942 118.74178,-0.86846 151.60371,-10.20785 207.19949,-32.57942 1.40897,-0.56696 2.89247,-2.44579 3.06979,-5.46393 1.34229,-22.84617 4.72121,-32.57675 4.8904,-46.22731 C 320.7945,388.42623 205.30603,411.1218 41.902732,345.75726 Z"
        fill="#35923a"
      />
      <ellipse
        cx="175.18839"
        cy="265.77231"
        rx="29.957975"
        ry="40.978203"
        transform="matrix(0.9631203,0.26907114,-0.19653659,0.98049649,0,0)"
        fill={`url(#${id('radialGradient15')})`}
      />
      <ellipse
        cx="-331.05313"
        cy="404.69684"
        rx="29.957975"
        ry="40.978203"
        transform="matrix(-0.9631203,0.26907114,0.19653659,0.98049649,0,0)"
        fill={`url(#${id('radialGradient17')})`}
      />
      <path
        d="m 167.44601,91.691474 c 82.03899,13.726886 96.83633,13.689486 180.45585,0.09217 1.54724,-0.251597 1.72907,1.713229 2.82956,2.829559 52.7177,53.476157 57.04295,86.476457 68.97971,122.697327 0.49064,1.48881 -1.29508,2.50918 -2.82956,2.82956 -112.12488,23.41088 -214.07439,18.27729 -325.553608,0.89586 -1.548851,-0.24149 -3.461872,-1.39517 -2.829557,-2.82956 18.637055,-42.27689 44.140605,-95.31797 76.118045,-123.685349 1.17265,-1.040272 1.28347,-3.088253 2.82956,-2.82956 z"
        fill={`url(#${id('linearGradient6')})`}
      />
      <path
        d="m 88.378134,218.99197 c -1.75957,3.8918 0.348985,6.86117 2.579804,9.92331 0.923034,1.267 1.28123,2.58859 2.83008,2.83008 111.479112,17.38141 207.866792,21.81453 319.991562,-1.59632 3.8308,-0.53705 6.7619,-9.51075 6.35882,-11.92063 -108.66561,17.6602 -225.39086,19.84269 -331.760266,0.76356 z"
        fill="#557d42"
      />
      <rect x="186.55983" y="373.18173" width="151.75641" height="39.971561" fill="#ffffff" rx="2.5437903" ry="2.5437903" />
      <ellipse cx="-494.2525" cy="-219.879" rx="14.212166" ry="8.6134338" transform="rotate(179.54431)" fill="#f4801c" />
      <ellipse cx="-15.443657" cy="-211.77919" rx="14.212166" ry="8.6134338" transform="rotate(179.54431)" fill="#f4801c" />
      <ellipse cx="101.51411" cy="-97.979889" rx="7.7626901" ry="9.0441055" transform="rotate(51.402724)" fill="#8b8b8b" />
    </svg>
  );
};
